import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EventPage from "./EventPage";
import SponsorDetail from "./SponsorDetail";
import AudioBackground from "./AudioBackground"; // Si está en otro archivo, expórtalo

function App() {
  return (
    <Router>
      <AudioBackground />
      <Routes>
        <Route path="/" element={<EventPage />} />
        <Route path="/sponsor/:slug" element={<SponsorDetail />} />
      </Routes>
    </Router>
  );
}

export default App;